import {Callback} from 'amplitude-js';

import EnvironmentService from './environmentService';

class TrackingService {
  private async getAmplitude() {
    const amplitude = await import('amplitude-js');
    return amplitude.getInstance();
  }

  public async init() {
    const instance = await this.getAmplitude();
    instance.init(
      EnvironmentService.isNodeEnvDev() ? '0051ce6d39b83fcdfdeece30f56c346f' : '7dddc9f90582c9f53e7f665948d358fc'
    );
  }

  private async logEvent(event: string, data?: any, callback?: Callback) {
    const instance = await this.getAmplitude();
    instance.logEvent(event, {...data, project: 'SALES_DEMOS'}, callback);
  }

  public logOpen() {
    this.logEvent('OPEN');
  }
}

export default new TrackingService();
